"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptorBeforeReject = void 0;
const ApiError_1 = require("../../../modules/base/errors/ApiError");
const interceptorBeforeReject = (error) => {
    const apiError = (new ApiError_1.ApiError(error.message)).setErrorOrigin(error);
    return Promise.reject(apiError);
};
exports.interceptorBeforeReject = interceptorBeforeReject;
